import solutionList from '@/view/solutions/list'
import solutionDetail from '@/view/solutions/detail'
import downloadFinish from '@/view/solutions/template/download_finish'
import downloadFree from '@/view/solutions/template/download_free'
import shareFinish from '@/view/solutions/template/share_finish'
import solutionDownload from '@/view/solutions/template/download'
import solutionBuy from '@/view/solutionBuy/list'

const solutionRouter = [
  {
    path: '/solutions/list.html',
    name: 'solution-list',
    component: solutionList,
    meta: {
      title: '解决方案馆'
    }
  },
  {
    path: '/limitFreeShare/:id/:activeId.html',
    redirect: '/solutions/detail/:id.html'
  },
  {
    path: '/solutions/detail/:id.html',
    name: 'solutionDetail',
    component: solutionDetail,
    meta: {
      title: '方案详情'
    }
  },
  {
    path: '/download/:id.html',
    name: 'download-finish',
    component: downloadFinish,
    meta: {
      title: '医院防疫合集-方案馆'
    }
  },
  {
    path: '/downloadFree/:id.html',
    name: 'download-free',
    component: downloadFree,
    meta: {
      title: '方案下载-方案馆'
    }
  },
  {
    path: '/shareFinish/:bizId/:activeId.html',
    name: 'share-finish',
    component: shareFinish,
    meta: {
      title: '方案馆分享成功'
    }
  },
  {
    path: '/solutionDownload.html',
    name: 'solutionDownload',
    component: solutionDownload,
    meta: {
      title: '方案下载'
    }
  },
  {
    path: '/solutionBuy.html',
    name: 'solutionBuy',
    component: solutionBuy,
    meta: {
      title: '我的方案',
      keepAlive: true
    }
  }

]

export default solutionRouter



// WEBPACK FOOTER //
// ./src/router/solutions/solution.js